import Link from "next/link";
import PhoneLink from "@/components/PhoneLink";

export default function SiteFooter() {
  return (
    <footer className="premium-footer">
      <div className="container footer-grid">
        <div className="footer-col">
          <div className="logo-text" style={{ color: "#fff" }}>
            AVT <span>KALAMBOLI</span>
          </div>
          <p>
            Dedicated to the core principles of Socialism, Equality, and Brotherhood taught by
            Maharaja Agrasen Ji.
          </p>
        </div>
        <div className="footer-col">
          <h3>Quick Links</h3>
          <Link href="/about">About Us</Link>
          <Link href="/committees">Our Committees</Link>
          {/* <a href="matrimony.html">Matrimony</a>
            <a href="hall-enquiry.html">Hall Enquiry</a> */}
        </div>
        <div className="footer-col">
          <h3>Contact Us</h3>
          <p>📍 Office no - 321, Riddhi Arcade, Kalamboli, Navi Mumbai, Maharashtra</p>
          <p>
            📞{" "}
            <PhoneLink phone="9324261020">+91 9324261020</PhoneLink>
            {" / "}
            <PhoneLink phone="7208093020">7208093020</PhoneLink>{" "}
          </p>
          <p>✉️ kalamboliavt@gmail.com</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Agroha Vikas Trust - Kalamboli . All Rights Reserved.</p>
        <p className="footer-credit">
          Developed by{" "}
          <a href="https://coderstreet.co.in" target="_blank" rel="noreferrer">
            Coder Street Technologies
          </a>
        </p>
      </div>
    </footer>
  );
}
